import { render, staticRenderFns } from "./worldmap-dialog.vue?vue&type=template&id=bc38d92c&scoped=true&"
import script from "./worldmap-dialog.vue?vue&type=script&lang=ts&"
export * from "./worldmap-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./worldmap-dialog.vue?vue&type=style&index=0&id=bc38d92c&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc38d92c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VDialog,VIcon})


/* vuetify-loader */
import installDirectives from "!../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
